import SplitTitle from '@/js/components/animations/split_title';

document.querySelectorAll('.js-split-title').forEach((el) => {
  // eslint-disable-next-line no-new
  new SplitTitle(el);
});
